import { combineReducers } from 'redux';

import listReducer from './listReducer';
import recordsReducer from './recordsReducer';

export default combineReducers({
  list: listReducer,
  records: recordsReducer,
});
